/**
 * Geschätzte Zeilenhöhe für virtualisierte Tabellen, deren Karten-Spalte die Karten **untereinander** stapelt
 * (Sollstundentafel, Deputat-Zuordnungen: LessonCard + Abstand `--spacing-4`). Gemessen: erste Karte 57 px, jede
 * weitere +32 px bzw. +40 px mit Zähler-Badge (count > 1), ohne Karte 49 px. Weicht die Schätzung ab, korrigiert der
 * Virtualizer beim Hochscrollen die Position und die Einträge springen.
 */
export const estimatedRowHeightByCards = (cardsInfos?: {
  defaultCards: { counter?: number }[][];
  subjectContainerCards: { counter?: number }[][];
}): number => {
  const counters = [...(cardsInfos?.defaultCards ?? []), ...(cardsInfos?.subjectContainerCards ?? [])].map(
    (group) => group[0]?.counter ?? 1,
  );
  if (counters.length === 0) return 49;
  return counters.slice(1).reduce((height, counter) => height + (counter > 1 ? 40 : 32), 57);
};

/** Karten nebeneinander (Stundenplan-Zuordnungen) – Zeilenhöhe unabhängig von der Kartenanzahl */
export const ROW_HEIGHT_CARDS_IN_ROW = 49;
